<form
    (ngSubmit)="save.emit(share)"
    #shareWithUserForm="ngForm"
    class="d-flex flex-column"
    [ngClass]="share != null && share.users.length > 0 ? '' : 'share-with-users-form'"
>
    <div class="input-group w-100">
        <input
            #input
            type="text"
            name="userToAdd"
            class="form-control"
            [(ngModel)]="userToAdd"
            [ngbTypeahead]="searchUsers$"
            [popupClass]="'custom-typeahead'"
            (selectItem)="selectUser($event)"
            [resultFormatter]="formatUserWithEmail"
            [inputFormatter]="formatUser"
            [resultTemplate]="resultTemplate"
            data-uit="share-with-user-input"
        />
        <ng-template #resultTemplate let-user="result" let-t="term">
            <div class="dropdown-item-wrapper align-items-center" data-uit="share-with-user-result-dropdown-item">
                <img *ngIf="user.picture" [src]="user.picture" class="profile-img me-2" />
                <div *ngIf="!user.picture" class="initials me-2">
                    {{ user | initials }}
                </div>
                <ngb-highlight [result]="user | fullNameWithEmail" [term]="t"></ngb-highlight>
            </div>
        </ng-template>
    </div>
    <div class="mt-4" [ngClass]="share != null && share.users.length > 0 ? '' : 'mb-auto'">
        <h4>{{ 'MY_WORKSPACE.MY_RESULTS.SHARING.SHARED_WITH' | translate }}</h4>
        <p *ngIf="share == null || share.users.length == 0">{{ 'MY_WORKSPACE.MY_RESULTS.SHARING.NOT_SHARED_YET' | translate }}</p>
        <table
            *ngIf="share != null && share.users.length > 0"
            class="table table-borderless shares-table table-sm mb-4"
            data-uit="share-with-user-shared-with-table"
        >
            <tbody>
                <tr *ngFor="let user of share.users">
                    <td class="initials-col">
                        <img *ngIf="user.picture" [src]="user.picture" class="profile-img" />
                        <div *ngIf="!user.picture" class="initials">
                            {{ user | initials }}
                        </div>
                    </td>
                    <td>{{ user | fullName }}</td>
                    <td class="d-flex justify-content-end">
                        <button
                            type="button"
                            class="btn ca-btn-icon"
                            (click)="removeUser(user)"
                            [ngbTooltip]="'MY_WORKSPACE.MY_RESULTS.SHARING.UNSHARE_WITH' | translate: { name: user | fullName }"
                            container="body"
                            data-uit="result-unshare-button"
                        >
                            <ca-icon name="trash" size="s"></ca-icon>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="d-flex justify-content-end">
        <button type="submit" [disabled]="!sharesHaveChanged" class="btn btn-primary" caAutoFocus data-uit="share-with-user-save-btn">
            {{ 'GENERAL.SAVE' | translate }}
        </button>
    </div>
</form>
